import { api } from '@/api/api';
import { MailSettingKeys } from '@/api/logical/mail';
import { apis, inWindow, isElectron } from '@/config';
class MailBlacklistImpl {
    constructor() {
        this.name = apis.mailBlacklistApiImpl;
        this.systemApi = api.getSystemApi();
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.storeApi = api.getDataStoreApi();
    }
    init() {
        if (inWindow()) {
            if (isElectron()) {
                if (window.location.pathname.includes('api_data_init')) {
                    this.systemApi.intervalEvent({
                        id: 'loopSetBlacklist',
                        eventPeriod: 'extLong',
                        seq: 0,
                        handler: ev => {
                            if (ev.seq % 2 === 0 && ev.seq > 0)
                                this.setBlacklist();
                        },
                    });
                }
            }
            else if (this.systemApi.isMainPage()) {
                this.systemApi.intervalEvent({
                    id: 'loopSetBlacklist',
                    eventPeriod: 'extLong',
                    seq: 0,
                    handler: ev => {
                        if (ev.seq % 2 === 0 && ev.seq > 0)
                            this.setBlacklist();
                    },
                });
            }
        }
        return this.name;
    }
    async setBlacklist() {
        const black = MailSettingKeys.nRefuseList;
        const currentList = await this.mailConfApi.doGetUserAttr([black]);
        const { refuselist = '' } = currentList;
        this.storeApi.putSync('refuselist', JSON.stringify(refuselist));
        return refuselist;
    }
    async addBlacklist(email) {
        const black = MailSettingKeys.nRefuseList;
        try {
            const currentList = await this.mailConfApi.doGetUserAttr([black]);
            const { refuselist = '' } = currentList;
            const refuselistArr = refuselist ? refuselist.split(',') : [];
            const newRefuselistArr = [...refuselistArr, email];
            if (!refuselistArr.includes(email)) {
                const res = await this.mailConfApi.doSetUserAttr({ refuselist: newRefuselistArr.join(',') });
                res && this.storeApi.putSync('refuselist', JSON.stringify(newRefuselistArr));
            }
            return true;
        }
        catch (error) {
            console.log('添加黑名单失败', error);
            return false;
        }
    }
}
const mailBlacklistImpl = new MailBlacklistImpl();
api.registerLogicalApi(mailBlacklistImpl);
export default mailBlacklistImpl;
